import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  Button,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";

import * as sportDUCK from "../../../../redux/ducks/sport.duck";
import {
  saveMasterSport,
  updateMasterSport,
  archiveMasterSport,
  unarchiveMasterSport,
} from "../../../crud/api/sports.crud";

const MasterSportsDialog = ({
  mode,
  setDialog,
  masterSport,
  sportActions,
}) => {
  const open = mode === "editing" || mode === "create";
  const isEditing = mode === "editing";
  const isArchived = Boolean(masterSport.archived_at);
  const title = isEditing ? "Edit Master Sport" : "New Master Sport";
  const [loading, setLoading] = useState(false);

  const create = async (values) => {
    try {
      await saveMasterSport(sportActions.updateMasterSports, values);
      setDialog("close");
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const update = async (values) => {
    try {
      await updateMasterSport(
        sportActions.updateMasterSports,
        values,
        masterSport.id
      );
      setDialog("close");
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const archive = async () => {
    try {
      setLoading(true);
      await archiveMasterSport(sportActions.updateMasterSports, masterSport.id);
      setDialog("close");
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const unarchive = async () => {
    try {
      setLoading(true);
      await unarchiveMasterSport(
        sportActions.updateMasterSports,
        masterSport.id
      );
      setDialog("close");
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setDialog("close")}
      id="master_sport_dialog"
    >
      <DialogTitle>{title}</DialogTitle>
      <Formik
        enableReinitialize
        initialValues={{
          ...masterSport,
          active: masterSport.active !== undefined ? masterSport.active : true,
        }}
        validate={(values) => {
          const errors = {};
          if (!values.name) errors.name = "Required field";
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setLoading(true);
          if (masterSport.id) update(values);
          else create(values);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form
            noValidate={true}
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={10}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    id="master_sport_name_input_dialog"
                    label="Sport"
                    name="name"
                    value={values.name || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.name && errors.name}
                    error={Boolean(touched.name && errors.name)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    id="master_sport_color_input_dialog"
                    label="Color"
                    name="color"
                    type="color"
                    value={values.color || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rowsMax="4"
                    variant="outlined"
                    id="master_sport_description_input_dialog"
                    label="Description"
                    name="description"
                    value={values.description || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              {isEditing && !isArchived && (
                <Button
                  id="archive_master_sport_btn_dialog"
                  onClick={archive}
                  disabled={loading}
                >
                  Archive
                </Button>
              )}
              {isEditing && isArchived && (
                <Button
                  id="unarchive_master_sport_btn_dialog"
                  onClick={unarchive}
                  disabled={loading}
                >
                  Restore
                </Button>
              )}
              <Button
                id="cancel_master_sport_btn_dialog"
                onClick={() => setDialog("close")}
                color="secondary"
              >
                Cancel
              </Button>
              <button
                type="submit"
                id="submit_master_sport_btn_dialog"
                disabled={isSubmitting || !values.name}
                className="btn btn-primary btn-elevate kt-login__btn-primary d-flex"
              >
                {isEditing ? "Submit" : "Create"}
                {loading && (
                  <CircularProgress
                    color="inherit"
                    size={18}
                    style={{ marginLeft: 10 }}
                  />
                )}
              </button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

MasterSportsDialog.propTypes = {
  mode: PropTypes.string.isRequired,
  setDialog: PropTypes.func.isRequired,
  masterSport: PropTypes.object.isRequired,
  sportActions: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => ({
  masterSport: store.sport.master_sport,
});

const mapDispatchToProps = (dispatch) => ({
  sportActions: bindActionCreators(sportDUCK.actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterSportsDialog);
